module.exports = __webpack_public_path__ + "56f06b46c709fe28ad15a7f1a6603897.png";